/* eslint-disable no-undef */
const EventBus = window.EventBus;
export const Search = {
  props: ['initialinventory', 'lang'],
  data(){
    return {
      conditionItems: [],
      conditionItemsSelected: [],
      conditionshow: false,
      yearshow: false,
      typeshow: false,
      makeshow: false,
      modelshow: false,
      conditionPivot: false,
      yearPivot: false,
      typePivot: false,
      makePivot: false,
      modelPivot: false,
      yearItems: [],
      yearItemsSelected: [],
      typeItems: [],
      typeItemsSelected: [],
      makeItems: [],
      makeItemsSelected: [],
      modelItems: [],
      modelItemsSelected: [],
      inventory: [],
      types: [],
      fuelTypes: [],
      fuelTypeSelected: null,
      pivot: null,
      bodytypeCount: 0,
      bodyTypeSelected: null,
      maxPrice: '',
      budgetMin: '',
      budgetMax: '',
      searchData: {
        conditions: [],
        years: [],
        types: [],
        makes: [],
        models: [],
        count: 0,
      },
      firstSearchData: null,
      urlToGo: '',
      filteringOptions: {
        filter: true,
        flags: "none",
        layout: "normal",
        limit: "0",
        make: "all",
        mileage: "all",
        model: "all",
        location: "all",
        price: "all",
        sort_by: "year",
        sort_by_condition: "desc",
        status: "all",
        stock: "all",
        tags: "all",
        trim: "all",
        type: "all",
        year: "all",
        component: "quicksearch",
      }
    }
  },
  created: function () {
    this.httpRequestInventory();
  },
  mounted: function () {
    EventBus.$on("conditionItemsSelected", (conditionItemsSelected) => {
      this.conditionItemsSelected = conditionItemsSelected;
    });

    EventBus.$on("conditionPivot", (conditionPivot) => {
      this.conditionPivot = conditionPivot;
    });

    EventBus.$on("searchData", (searchData) => {
      this.searchData = searchData;
    });

    EventBus.$on("maxPrice", (maxPrice) => {
      this.maxPrice = maxPrice;
    });
  },
  methods: {
    httpRequestInventory() {
      EventBus.httpRequestInventory(null, this.entryPoint, this.filteringOptions);
  },
  entryPoint(inventory) {
    this.inventory = inventory;
    this.bodytypeCount = inventory.length;
    this.filteredInventory = inventory;
    this.load();

    this.inventory.forEach(item => {
      if(this.types.indexOf(item.bodystyle) == -1 && item.bodystyle != 'Other' && item.bodystyle != '')
        this.types.push(item.bodystyle)
    });

    this.types = this.types.sort();
  },
  toggleCondition(component, condition){
    this.setPivot(component);
    this.updateChecked({component, checked: [condition]});
    this.updateSelected({component, checked: [condition]});

    jQuery('.condition-toggle').removeClass('border-primary').addClass('border-white');
    jQuery(`.${condition.toLowerCase()}-toggle`).removeClass('border-white').addClass('border-primary');
  },
  filterMaxPrice(maxPrice){
    maxPrice = maxPrice == '' ? 0 : maxPrice;
    this.maxPrice = Number(maxPrice);
    
    EventBus.$emit("maxPrice", this.maxPrice);
    this.filterInventory();

    if(this.maxPrice == 0)
      this.maxPrice = '';
  },
  filterBodyType(type) {
    this.bodyTypeSelected = type;
    this.fuelTypeSelected = null;
    // Filtra el inventario por el tipo proporcionado
    const filteredInventory = this.inventory.filter(item => item.bodystyle === type);
    this.bodytypeCount = filteredInventory.length;
  
    // Extrae los fueltypes únicos de los vehículos filtrados
    const uniqueFuelTypes = [];
    filteredInventory.forEach(item => {
      if (uniqueFuelTypes.indexOf(item.fueltype) === -1 && item.fueltype !== 'Other' && item.fueltype !== 'PHEV') {
        uniqueFuelTypes.push(item.fueltype);
      }
    });

    jQuery('.types-cards').removeClass('border-primary').addClass('border-white');
    jQuery(`.${type?.toLowerCase().replace(/[\s/]+/g, '-')}-card`).removeClass('border-white').addClass('border-primary');
  
    // Guarda los fueltypes únicos en un array
    this.fuelTypes = uniqueFuelTypes.sort();
  },
  filterFuelType(fuelType) {
    this.fuelTypeSelected = fuelType;
    // Filtra el inventario por el tipo de combustible y el bodytype anteriormente proporcionado
    const filteredInventory = this.inventory.filter(item => item.fueltype === fuelType && item.bodystyle === this.bodyTypeSelected);
    this.bodytypeCount = filteredInventory.length;

    jQuery('.fuel-cards').removeClass('border-primary').addClass('border-white');
    jQuery(`.${fuelType.toLowerCase()}-card`).removeClass('border-white').addClass('border-primary');
  },
    buildUrl(){
      let url = '';
      if(this.conditionItemsSelected.length > 0)
        url += '/condition/' + this.conditionItemsSelected.map((item) => {return item.replace(/ /g, '-').toLowerCase()}).join(',');
      if(this.yearItemsSelected.length > 0)
        url += '/year/' + this.yearItemsSelected.map((item) => {return item.replace(/ /g, '-').toLowerCase()}).join(',');
      if(this.makeItemsSelected.length > 0)
        url += '/make/' + this.makeItemsSelected.map((item) => {return item.replace(/ /g, '-').toLowerCase()}).join(',');
      if(this.modelItemsSelected.length > 0)
        url += '/model/' + this.modelItemsSelected.map((item) => {return item.replace(/ /g, '-').toLowerCase()}).join(',');
      if(this.bodyTypeSelected != null)
        url += '/bodystyle/' + this.bodyTypeSelected.replace(/ /g, '-').toLowerCase();
      if(this.fuelTypeSelected != null)
        url += '/fueltype/' + this.fuelTypeSelected.replace(/ /g, '-').toLowerCase();
      if(this.maxPrice != '')
        url += '/price/0-' + this.maxPrice;
      if(this.typeItemsSelected.length > 0)
        url += '/bodystyle/' + this.typeItemsSelected.map((item) => {return item.replace(/ /g, '-').toLowerCase()}).join(',');
      if(this.budgetMin != '' && this.budgetMax != '')
        url += '/payment/' + this.budgetMin + '-' + this.budgetMax;
      if(url.length > 0)
          url += '/';
      if(this.lang == "fr_CA")
        this.urlToGo = '/recherche' + url;
      else
        this.urlToGo = '/search' + url;
    },  
    filterInventory(){
      if(this.conditionItemsSelected.length == 0
      && this.yearItemsSelected.length == 0
      && this.makeItemsSelected.length == 0
      && this.typeItemsSelected.length == 0
      && this.modelItemsSelected.length == 0
      && this.maxPrice == '')
      {
        this.filteredInventory = this.inventory;
        this.load();
      }
      else
      {
        this.filteredInventory = [];
        this.inventory.forEach(item => {
          var filter = true;
          if(filter && this.conditionItemsSelected.length > 0
          && this.conditionItemsSelected.indexOf(item.condition) == -1){
            filter = false
          }
          if(filter && this.yearItemsSelected.length > 0
          && this.yearItemsSelected.indexOf(item.year) == -1){
            filter = false
          }
          if(filter && this.makeItemsSelected.length > 0
          && this.makeItemsSelected.indexOf(item.make) == -1){
            filter = false
          }
          if(filter && this.modelItemsSelected.length > 0
          && this.modelItemsSelected.indexOf(item.model) == -1){
            filter = false
          }
          if(filter && this.typeItemsSelected.length > 0
            && this.typeItemsSelected.indexOf(item.bodystyle) == -1){
              filter = false
          }
          if(filter && this.maxPrice != ''){
            if(item.price <= 0 || item.price > Number(this.maxPrice))
              filter = false;
          }

          if(filter){
            this.filteredInventory.push(item);
          }
        })

        this.load();
      }
    },
    hideAllComponents()
    {
      this.conditionshow = false;
      this.yearshow = false;
      this.makeshow = false;
      this.modelshow = false;
      this.typeshow = false;
    },
    hideComponents(component)
    {
      this.conditionshow = false;
      this.yearshow = false;
      this.makeshow = false;
      this.modelshow = false;
      this.typeshow = false;
      this[component + 'show'] = true;
    },
    updateChecked(params){
      this[params['component'] + 'ItemsSelected'] = params['checked'];
      EventBus.$emit("conditionItemsSelected", this.conditionItemsSelected);
    },
    updateSelected(){
      this.filterInventory();
      this.buildUrl();
    },
    search(){
        this.updateSelected();
        if(this.urlToGo.length > 0){
            window.location.href = this.urlToGo;
            this.searchEvent();
        }
    },
    searchEvent(){
      var payload = {'event_category': 'LBX-SRP-Home', 'event_label': ' LBX-' + this.urlToGo};
      window.sendGAEvent('LBX-Search', payload);
    },
    setPivot(component)
    {
      this[component + 'Pivot'] = true;
      EventBus.$emit("conditionPivot", this.conditionPivot);
    },
    unsetPivot(component)
    {
      this[component + 'Pivot'] = false;
    },
    load()
    {
      this.searchData = {
        conditions: [],
        years: [],
        makes: [],
        models: [],
        types: [],
        count: 0,
      }

      EventBus.$emit("searchData", this.searchData);

      this.filteredInventory.forEach(item => {
        this.searchData.count++;
        if(this.searchData.conditions.indexOf(item.condition) == -1)
          this.searchData.conditions.push(item.condition)
        if(this.searchData.years.indexOf(item.year) == -1)
          this.searchData.years.push(item.year)
        if(this.searchData.makes.indexOf(item.make) == -1)
          this.searchData.makes.push(item.make)
        if(this.searchData.models.indexOf(item.model) == -1)
          this.searchData.models.push(item.model)
        if (
          item.bodystyle &&                          
          item.bodystyle !== 'Other' && 
          item.bodystyle !== '' && 
          !this.searchData.types.includes(item.bodystyle)
        ) {
          this.searchData.types.push(item.bodystyle)
        }
      })

      if(!this.firstSearchData){
        this.firstSearchData = this.searchData;
      }

      if(!this.conditionPivot){
       this.conditionItems = this.searchData.conditions.sort();
      }

      if(!this.yearPivot){
        this.yearItems = this.searchData.years.sort(function(a, b){return b-a})
      }

      if(!this.makePivot){
        this.makeItems = this.searchData.makes.sort();
      }

      if(!this.modelPivot){
        this.modelItems = this.searchData.models.sort();
      }

      if(!this.typePivot){
        this.typeItems = this.searchData.types.sort();
      }
    },
  },
}
